import { BrowserAuthError, InteractionRequiredAuthError, ServerError } from "@azure/msal-browser";

const ENTRA_DEVICE_REGISTRATION_ERROR_CODE = "AADSTS700003";

export function isEntraDeviceRegistrationError(error: unknown): error is ServerError {
  return (
    error instanceof ServerError &&
    error.errorCode === "invalid_grant" &&
    error.errorMessage.includes(ENTRA_DEVICE_REGISTRATION_ERROR_CODE)
  );
}

export function isSessionRecoveryMsalError(error: unknown): boolean {
  return (
    error instanceof InteractionRequiredAuthError ||
    error instanceof BrowserAuthError ||
    isEntraDeviceRegistrationError(error)
  );
}
